<template>
  <div
    class="sli-encroach"
    :class="{ 'is-locked': !enabled && !readonly }"
  >
    <header class="sli-encroach__head">
      التعدي والاستخدام العام
      <small v-if="!enabled && !readonly">ارفع ملف KML لتفعيل هذا القسم لهذه القطعة</small>
    </header>
    <fieldset
      class="sli-lock"
      :disabled="!readonly && !enabled"
    >
      <div class="sli-grid sli-grid--fit">
        <sli-field
          v-model="land.development_map_62_status"
          label="موقف الإدراج بخريطة التنمية 62"
          :input-id="`${uid}-map62`"
          fit="22"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="land.usage_type"
          label="نوع الاستخدام"
          :input-id="`${uid}-usage`"
          fit="12"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="land.code"
          label="كود الأرض"
          :input-id="`${uid}-code`"
          compact
          :disabled="readonly || !enabled"
          @blur="$emit('identity-change')"
        />
        <sli-field
          v-model="land.encroached_area_m2"
          label="المساحات المتعدى عليها م²"
          :input-id="`${uid}-enc-area`"
          inputmode="decimal"
          compact
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="land.unallocated_vacant_area"
          label="مساحة فضاء لم تخصص"
          :input-id="`${uid}-vacant`"
          fit="14"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="land.reservation_method"
          label="أسلوب التحفظ على الأرض"
          :input-id="`${uid}-reserve`"
          fit="16"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="land.usage_type_description"
          label="وصف نوع الاستخدام"
          :input-id="`${uid}-usage-desc`"
          span="6"
          multiline
          :disabled="readonly || !enabled"
        />
      </div>

      <div class="sli-enc-head">
        <span>بيانات المتعدين</span>
        <button
          v-if="!readonly"
          type="button"
          class="sli-add-btn"
          :disabled="readonly || !enabled"
          @click="$emit('add-encroacher')"
        >
          + إضافة متعدٍ
        </button>
      </div>
      <div
        v-for="(row, index) in (land.encroacher_data || [])"
        :key="row._key || index"
        class="sli-grid sli-grid--fit sli-enc-row"
      >
        <sli-field
          v-model="row.name"
          label="الاسم"
          :input-id="`${uid}-enc-name-${index}`"
          fit="14"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="row.national_id"
          label="رقم قومي"
          :input-id="`${uid}-enc-nid-${index}`"
          inputmode="numeric"
          maxlength="14"
          fit="14"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="row.phone"
          label="هاتف"
          :input-id="`${uid}-enc-phone-${index}`"
          type="tel"
          inputmode="tel"
          fit="12"
          :disabled="readonly || !enabled"
        />
        <sli-field
          v-model="row.area_m2"
          label="مساحة م²"
          :input-id="`${uid}-enc-m2-${index}`"
          inputmode="decimal"
          compact
          :disabled="readonly || !enabled"
        />
        <div
          v-if="!readonly"
          class="sli-cell sli-cell--action"
        >
          <button
            type="button"
            class="sli-link-btn"
            :disabled="readonly || !enabled"
            @click="$emit('remove-encroacher', index)"
          >
            حذف
          </button>
        </div>
        <sli-field
          v-model="row.notes"
          label="ملاحظات"
          :input-id="`${uid}-enc-notes-${index}`"
          span="6"
          fit="18"
          :disabled="readonly || !enabled"
        />
        <div class="sli-cell sli-cell--tenure">
          <span class="sli-cell__label">نوع الخدمة</span>
          <div class="sli-radios">
            <label>
              <input
                :checked="Number(row.service_id) !== 110"
                type="radio"
                :name="`${uid}-svc-${index}`"
                :disabled="readonly || !enabled"
                @change="setService(row, 109)"
              >
              أراضي زراعية
            </label>
            <label>
              <input
                :checked="Number(row.service_id) === 110"
                type="radio"
                :name="`${uid}-svc-${index}`"
                :disabled="readonly || !enabled"
                @change="setService(row, 110)"
              >
              الأحكار (المباني)
            </label>
          </div>
        </div>
        <div
          v-if="readonly"
          class="sli-cell sli-cell--action sli-enc-project"
        >
          <b-button
            v-if="row.project_id"
            size="sm"
            variant="outline-success"
            :to="{ name: 'project_details', params: { id: row.project_id } }"
          >
            المشروع {{ row.project_id }}
          </b-button>
          <template v-else-if="canCreateProject">
            <b-button
              size="sm"
              variant="primary"
              :disabled="!row.id || creatingKey === encKey(row, 109)"
              @click="$emit('create-project', { enc: row, serviceId: 109 })"
            >
              إنشاء مشروع أراضي زراعية
            </b-button>
            <b-button
              size="sm"
              variant="outline-primary"
              :disabled="!row.id || creatingKey === encKey(row, 110)"
              @click="$emit('create-project', { enc: row, serviceId: 110 })"
            >
              إنشاء مشروع الأحكار
            </b-button>
          </template>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import SliField from './SliField.vue'
import { SERVICE_AGRICULTURAL, SERVICE_AHKAR, serviceLabel } from '../formModel'

export default {
  name: 'SliEncroachFields',
  components: { SliField, BButton },
  props: {
    land: { type: Object, required: true },
    uid: { type: String, required: true },
    enabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    creatingKey: { type: String, default: '' },
    canCreateProject: { type: Boolean, default: false },
  },
  methods: {
    encKey(enc, serviceId) {
      return `${enc.id || enc._key}-${serviceId}`
    },
    setService(row, serviceId) {
      row.service_id = serviceId === SERVICE_AHKAR ? SERVICE_AHKAR : SERVICE_AGRICULTURAL
      row.service_label = serviceLabel(row.service_id)
    },
  },
}
</script>
